import "./VpnGenix.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import DigitalFreedom from "./sections/DigitalFreedom";
import MissionAndExpertiseStats from "./sections/Missionandexpertisestats";
import LatestSecurityInsights from "./sections/Latestsecurityinsights";
import TopRatedVPNComparison from "./sections/TopRatedVPNComparison";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
import Topvpnpicksintro from "./sections/Topvpnpicksintro";
import FaqCommandCenter from "./sections/FaqCommandCenter";
import Methodology from "./sections/Methodology";
import EditorialIndependencePromise from "./sections/EditorialIndependencePromise";
import TrustPointsGrid from "./sections/TrustPointsGrid";
export default function VpnGenixPage() {
  return <div>
      <Header />
      <div id="hero">
        <Hero />
      </div>
      <div id="trustbar">
      </div>
      <div id="topvpnpicksintro">
        <Topvpnpicksintro />
      </div>
      <div id="digital-freedom">
        <DigitalFreedom />
      </div>
      <div id="vpn-features">
        <TopRatedVPNComparison />
      </div>
      <div id="mission-and-expertise">
        <MissionAndExpertiseStats />
      </div>
      <div id="methodology">
        <Methodology />
      </div>
      <div id="editorial-independence-promise">
        <EditorialIndependencePromise />
      </div>
      <div id="trust-points-grid">
        <TrustPointsGrid />
      </div>
      <div id="security-insights">
        <LatestSecurityInsights />
      </div>
      <div id="faq-command-center">
        <FaqCommandCenter />
      </div>
      <div id="contact">
        <Contact />
      </div>
      <Footer />
    </div>;
}